import { Button } from '@/shared/ui/Button';

type Props = {
  pagina: number;
  totalPaginas: number;
  total: number;
  tamanhoPagina: number;
  onMudarPagina: (p: number) => void;
};

/**
 * Rodapé "Mostrando X-Y de N • ‹ Anterior • página N de M • Próxima ›"
 * para listas paginadas. Esconde-se sozinho quando há só uma página —
 * evita poluir telas pequenas com controles inúteis.
 */
export function Paginacao({
  pagina,
  totalPaginas,
  total,
  tamanhoPagina,
  onMudarPagina,
}: Props) {
  if (total === 0 || totalPaginas <= 1) return null;
  const ini = (pagina - 1) * tamanhoPagina + 1;
  const fim = Math.min(pagina * tamanhoPagina, total);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '8px 12px',
        borderTop: '1px solid #e5e7eb',
        fontSize: 13,
        color: '#475569',
        flexWrap: 'wrap',
      }}
    >
      <span>
        Mostrando <strong>{ini.toLocaleString('pt-BR')}</strong>–
        <strong>{fim.toLocaleString('pt-BR')}</strong> de{' '}
        <strong>{total.toLocaleString('pt-BR')}</strong>
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Button
          onClick={() => onMudarPagina(pagina - 1)}
          disabled={pagina <= 1}
          aria-label="Página anterior"
        >
          ‹ Anterior
        </Button>
        <span>
          Página <strong>{pagina}</strong> de{' '}
          <strong>{totalPaginas}</strong>
        </span>
        <Button
          onClick={() => onMudarPagina(pagina + 1)}
          disabled={pagina >= totalPaginas}
          aria-label="Próxima página"
        >
          Próxima ›
        </Button>
      </div>
    </div>
  );
}
